export default "__VITE_ASSET__c8ee0efc__"